import React from "react";
import css from "./AdminLayout.module.scss";
import AdminSidebar from "./AdminSidebar/AdminSidebar";
import { Outlet } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { FirestoreDB } from "utils/firebase";
import { useUser } from "stores/useUser";
import { useQuery } from "react-query";
import { ONEDAY } from "utils/common";
import LoaderScreen from "components/Loader";

const AdminLayout = () => {
  const { user } = useUser();
  const organizationId = user?.subscription?.organization_id;

  const {
    data: orgDetails,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["organizationDetails", organizationId],
    queryFn: async () => {
      const snap = await getDoc(
        doc(FirestoreDB, `organizations/${organizationId}`)
      );
      return snap.data();
    },
    enabled: Boolean(organizationId),
    staleTime: ONEDAY,
  });
  if (isLoading) {
    return <LoaderScreen />;
  }
  if (isError) {
    return <div>Error fetching organization details</div>;
  }
  return (
    <div className={css.container}>
      {/* Sidebar */}
      <AdminSidebar orgDetails={orgDetails} />

      <div className={css.analytics}>
        <Outlet context={[orgDetails]} />
      </div>
    </div>
  );
};

export default AdminLayout;
